import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/language-hooks';
import { Sparkles, X } from 'lucide-react';
import { useState } from 'react';
import { NewYearGoalPlanningDialog } from './NewYearGoalPlanningDialog';

interface NewYearGoalBannerProps {
  onDismiss?: () => void;
}

export const NewYearGoalBanner = ({ onDismiss }: NewYearGoalBannerProps) => {
  const { t } = useLanguage();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  const handleDismiss = () => {
    setIsDismissed(true);
    onDismiss?.();
  };

  const handleGetStarted = () => {
    setIsDialogOpen(true);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <>
      <div className='from-primary/10 via-primary/5 border-primary/20 border-b bg-gradient-to-r to-transparent'>
        <div className='container mx-auto px-4 py-3'>
          <div className='flex items-center justify-between gap-4'>
            <div className='flex min-w-0 flex-1 items-center gap-3'>
              <div className='flex-shrink-0'>
                <Sparkles className='text-primary h-5 w-5' />
              </div>
              <div className='min-w-0 flex-1'>
                <p className='text-foreground truncate text-sm font-medium'>
                  {t('goalPlanning.banner.title')}
                </p>
                <p className='text-muted-foreground truncate text-xs'>
                  {t('goalPlanning.banner.description')}
                </p>
              </div>
            </div>
            <div className='flex flex-shrink-0 items-center gap-2'>
              <Button size='sm' onClick={handleGetStarted} className='whitespace-nowrap'>
                {t('goalPlanning.banner.getStarted')}
              </Button>
              <Button
                variant='ghost'
                size='icon'
                onClick={handleDismiss}
                className='h-8 w-8'
                aria-label={t('common.cancel')}
              >
                <X className='h-4 w-4' />
              </Button>
            </div>
          </div>
        </div>
      </div>

      <NewYearGoalPlanningDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        onComplete={handleDismiss}
      />
    </>
  );
};
